import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing a fence icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <FenceIcon width={24} />
 */
const FenceIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M20 13.9999H19V11.9999H20C20.55 11.9999 21 11.5499 21 10.9999C21 10.4499 20.55 9.99991 20
            9.99991H19V6.99991L16.71 4.70991C16.51 4.50991 16.26 4.41991 16 4.41991C15.74 4.41991 15.49
            4.51991 15.29 4.70991L14 5.99991L12.71 4.70991C12.51 4.50991 12.26 4.41991 12 4.41991C11.74
            4.41991 11.49 4.51991 11.29 4.70991L10 5.99991L8.71 4.70991C8.51 4.50991 8.26 4.40991 8 4.40991C7.74
            4.40991 7.49 4.50991 7.29 4.69991L5 6.99991V9.99991H4C3.45 9.99991 3 10.4499 3 10.9999C3 11.5499
            3.45 11.9999 4 11.9999H5V13.9999H4C3.45 13.9999 3 14.4499 3 14.9999C3 15.5499 3.45 15.9999 4
            15.9999H5V18.9999C5 19.5499 5.45 19.9999 6 19.9999H10H14H18C18.55 19.9999 19 19.5499 19
            18.9999V15.9999H20C20.55 15.9999 21 15.5499 21 14.9999C21 14.4499 20.55 13.9999 20 13.9999ZM15
            7.82991L16 6.82991L17 7.82991V9.99991H15V7.82991ZM17 11.9999V13.9999H15V11.9999H17ZM11 7.82991L12
            6.82991L13 7.82991V9.99991H11V7.82991ZM13 11.9999V13.9999H11V11.9999H13ZM7 7.82991L8 6.82991L9
            7.82991V9.99991H7V7.82991ZM7 11.9999H9V13.9999H7V11.9999ZM7 17.9999V15.9999H9V17.9999H7ZM11
            17.9999V15.9999H13V17.9999H11ZM17 17.9999H15V15.9999H17V17.9999Z`}
        />
    </SvgIcon>
)

FenceIcon.defaultProps = defaultProps

export { FenceIcon }
